import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthenticationService {
    public token: string;
    public currentUser: any;

    constructor(private http: Http) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;
    }

    // need to include the checkbox as to determine between localstorage and sessionstroage
    login(user_name: string, password: string, remember: boolean): Observable<boolean> {
        return this.http.post(`${environment.api}auth`, { user_name, password })

            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                if (response) {
                    let token = response.json() && response.json().token;
                    let name = response.json() && response.json().name;
                    let profile_pic = response.json() && response.json().profile_pic;
                    if (token) {
                        // set token property
                        this.token = token;
                        // store username and jwt token in local storage to keep user logged in between page refreshes
                        if (remember) {
                            localStorage.setItem('currentUser', JSON.stringify({ user_name: user_name, name: name, token: token,
                                profile_pic: profile_pic }));
                        } else {
                            sessionStorage.setItem('currentUser', JSON.stringify({ user_name: user_name, name: name, token: token,
                                profile_pic: profile_pic }));
                            sessionStorage.setItem('ImagesOption', 'hide');
                        }

                        // return true to indicate successful login
                        return true;
                    } else {
                        // return false to indicate failed login
                        return false;
                    }
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }
    logout(): void {

        // clear token remove user from local storage to log user out
        this.token = null;
        localStorage.removeItem('currentUser');
        sessionStorage.removeItem('currentUser');
        localStorage.removeItem('user');
        sessionStorage.clear();
        localStorage.clear();
    }

    isLoggedIn(): any {
        throw new Error('Method not implemented.');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication.service.ts